import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const ListingViewHeaderSearchContext_Box_1 = styled.div`
  margin-bottom: 32px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-bottom: 40px;
  }
`;
